import React from 'react';
import { AccordionProvider, AccordionProviderType } from './AccordionProvider';

export const AccordionView = (props: AccordionProviderType): JSX.Element => {
  return <AccordionProvider {...props}>{props.children}</AccordionProvider>;
};
